export const EXCHANGE_ROUTES = {
  restars: { source: 'restars', target: 'coins', unit: 1, gain: 500, limit: 10000, rate: '1 ReStar = 500 рекоинов' },
  coins: { source: 'coins', target: 'spins', unit: 800, gain: 1, limit: 10000, rate: '800 рекоинов = 1 крутка' },
};

export function exchangeMaximum(route, balances) {
  const r = EXCHANGE_ROUTES[route];
  if (!r) return 0;
  const balance = Math.max(0, Number(balances?.[r.source]) || 0);
  return Math.min(r.limit, Math.floor(balance / r.unit)) * r.unit;
}

export function exchangeQuote(route, raw, balances) {
  const r = EXCHANGE_ROUTES[route];
  const text = String(raw ?? '').trim();
  if (!r) return { valid: false, received: 0, error: 'Выбери направление обмена.' };
  if (!text || text === '0') return { valid: false, received: 0, error: '' };
  const amount = Number(text);
  if (!/^\d+$/.test(text) || !Number.isSafeInteger(amount) || amount < 1)
    return { valid: false, received: 0, error: 'Укажи целое положительное число.' };
  if (amount % r.unit !== 0)
    return { valid: false, received: 0, error: 'Количество рекоинов должно быть кратно 800.' };
  const count = amount / r.unit;
  const received = count * r.gain;
  if (count > r.limit)
    return { valid: false, received, error: `За один обмен — не больше ${r.limit.toLocaleString('ru-RU')} ${route === 'restars' ? 'ReStars' : 'круток'}.` };
  if (amount > Math.max(0, Number(balances?.[r.source]) || 0))
    return { valid: false, received, error: route === 'restars' ? 'Недостаточно ReStars.' : 'Недостаточно рекоинов.' };
  return { valid: true, amount, count, received, error: '' };
}

export function exchangeAmount(currency, amount) {
  const forms = currency === 'coins' ? ['рекоин', 'рекоина', 'рекоинов'] : ['крутка', 'крутки', 'круток'];
  const category = new Intl.PluralRules('ru-RU').select(amount);
  const unit = currency === 'restars' ? 'ReStars' : forms[category === 'one' ? 0 : category === 'few' ? 1 : 2];
  return `${amount.toLocaleString('ru-RU')} ${unit}`;
}

export function exchangeThemePayout(price) {
  return Math.floor(Math.max(0, Math.floor(Number(price) || 0)) * 70 / 100);
}
